export interface Screen<E> {
  readonly pointed: () => E | null;
  readonly top: (element: E) => number;
  readonly connected: (element: E) => boolean;
  readonly where: () => string;
  readonly scrollBy: (pixels: number) => void;
}

export interface Held<E> {
  readonly element: E;
  readonly top: number;
  readonly where: string;
}

export function hold<E>(screen: Screen<E>): Held<E> | null {
  const element = screen.pointed();
  return element === null ? null : { element, top: screen.top(element), where: screen.where() };
}

export function keep<E>(screen: Screen<E>, held: Held<E>): void {
  if (!screen.connected(held.element) || screen.where() !== held.where) return;
  const moved = screen.top(held.element) - held.top;
  if (moved !== 0) screen.scrollBy(moved);
}
